import { InstoreTemplate } from "../models/instoreTemplate";
import { InstoreType } from "../models/instoreType";

// Resolves the active "Week" template available for a given store format.
// A store format belongs to one instore type (InstoreType.store_formats), and
// there is normally one Week template per instore type. So: store_format →
// its instore type → the Week template of that type. Returns undefined when no
// format is given or nothing matches.
export default function resolveWeekTemplateForStoreFormat(
  weekTemplates: InstoreTemplate[],
  instoreTypes: InstoreType[],
  storeFormatId?: number | null,
): InstoreTemplate | undefined {
  if (!storeFormatId) return undefined;
  const type = instoreTypes.find((it) =>
    it.store_formats?.some((sf) => sf.id === storeFormatId),
  );
  if (!type) return undefined;
  return weekTemplates.find((wt) => wt.instore_type_id === type.id);
}
